import { Inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoginService } from '../services/login.service';
import { Location} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  private returnUrl: string = "";
  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private oauthService: OAuthService, 
    private router: Router,
    private loginService: LoginService,
    private location: Location
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!!this.oauthService.getAccessToken() && localStorage.getItem('loggedInUser') != null) {
      return true;
    }
    /* Make sure we don't send back concatenation of multiple failed requests */
    var re = new RegExp('returnUrl', 'g');
    if (re.test(this.location.path()) == false) {
      this.returnUrl = this.location.path();
    }

    this.loginService.changeExpired(true);
    this.loginService.logout();
    var re = new RegExp('login', 'g');
    if (this.returnUrl != "" && re.test(this.returnUrl) == false) {
      this.router.navigate(['login'], { queryParams: { returnUrl: this.returnUrl } });
    } else {
      this.router.navigate(['login'])
    }
    return false;
  }

}
